<template>
<div class="toggle-header-type">
    <Radio
        :value="true"
        :checked="useTextHeader"
        @input="$emit('update:useTextHeader', $event)"
        name="header"
        >Text Header</Radio>
    <Radio
        :value="false"
        :checked="useTextHeader"
        @input="$emit('update:useTextHeader', $event)"
        name="header"
        >Image Header</Radio>
</div>
</template>

<script>
export default {
    name: 'ConfigHeaderType',
    props: {
        useTextHeader: Boolean
    },
}
</script>

<style lang="scss" scoped>
.toggle-header-type {
    display: flex;
    flex-wrap: wrap;
    > .field {
        margin-right: 1.5rem;
    }
}
</style>
